module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.loading) ? _c('div', {
    staticClass: "budget"
  }, [_vm._v("\n        Tryk udenfor input-feltet, når du har indtastet et beløb, for at gemme budgettet.\n        "), _c('br'), _c('br'), _vm._v("\n        Scroll til højre på skærmen for at se alle månederne.\n        "), _c('br'), _c('br'), _vm._v(" "), _vm._l((_vm.accountCategories), function(accountCategory) {
    return (_vm.accountCategories.length > 0) ? _c('div', {
      key: accountCategory.slug,
      staticClass: "placeholder padding",
      staticStyle: {
        "overflow-x": "scroll",
        "margin-bottom": "15px"
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("\n                " + _vm._s(accountCategory.name) + "\n            ")]), _vm._v(" "), (accountCategory.accounts.length > 0) ? _c('table', [_vm._m(0, true), _vm._v(" "), _c('tbody', [_vm._l((accountCategory.accounts), function(account) {
      return _c('tr', {
        key: account.uuid
      }, [_c('td', [_vm._v(_vm._s(account.account_number))]), _vm._v(" "), _c('td', {
        staticClass: "name"
      }, [_vm._v(_vm._s(account.name))]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.january),
          expression: "account.budgets.january"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.january)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'january', account.budgets.january)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "january", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.february),
          expression: "account.budgets.february"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.february)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'february', account.budgets.february)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "february", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.march),
          expression: "account.budgets.march"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.march)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'march', account.budgets.march)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "march", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.april),
          expression: "account.budgets.april"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.april)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'april', account.budgets.april)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "april", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.may),
          expression: "account.budgets.may"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.may)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'may', account.budgets.may)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "may", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.june),
          expression: "account.budgets.june"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.june)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'june', account.budgets.june)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "june", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.july),
          expression: "account.budgets.july"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.july)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'july', account.budgets.july)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "july", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.august),
          expression: "account.budgets.august"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.august)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'august', account.budgets.august)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "august", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.september),
          expression: "account.budgets.september"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.september)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'september', account.budgets.september)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "september", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.october),
          expression: "account.budgets.october"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.october)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'october', account.budgets.october)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "october", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.november),
          expression: "account.budgets.november"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.november)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'november', account.budgets.november)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "november", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.december),
          expression: "account.budgets.december"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.december)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'december', account.budgets.december)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "december", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', {
        staticClass: "totals"
      }, [_vm._v("\n                            " + _vm._s(_vm._f("currency")(Number(account.budgets.january) + Number(account.budgets.february) + Number(account.budgets.march) + Number(account.budgets.april) + Number(account.budgets.may) + Number(account.budgets.june) + Number(account.budgets.july) + Number(account.budgets.august) + Number(account.budgets.september) + Number(account.budgets.october) + Number(account.budgets.november) + Number(account.budgets.december))) + "\n                        ")])])
    }), _vm._v(" "), _c('tr', {
      staticClass: "totals"
    }, [_c('td'), _vm._v(" "), _c('td', {
      staticClass: "name"
    }, [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.january))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.february))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.march))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.april))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.may))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.june))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.july))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.august))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.september))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.october))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.november))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.december))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = _vm.count + Number(account.budgets.january) + Number(account.budgets.february) + Number(account.budgets.march) + Number(account.budgets.april) + Number(account.budgets.may) + Number(account.budgets.june) + Number(account.budgets.july) + Number(account.budgets.august) + Number(account.budgets.september) + Number(account.budgets.october) + Number(account.budgets.november) + Number(account.budgets.december)
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")])])], 2)]) : _c('div', [_vm._v("\n                Ingen konti i denne kategori\n            ")])]) : _vm._e()
  })], 2) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "name"
  }, [_vm._v("Konto")]), _vm._v(" "), _c('th', [_vm._v("Jan")]), _vm._v(" "), _c('th', [_vm._v("Feb")]), _vm._v(" "), _c('th', [_vm._v("Mar")]), _vm._v(" "), _c('th', [_vm._v("Apr")]), _vm._v(" "), _c('th', [_vm._v("Maj")]), _vm._v(" "), _c('th', [_vm._v("Jun")]), _vm._v(" "), _c('th', [_vm._v("Jul")]), _vm._v(" "), _c('th', [_vm._v("Aug")]), _vm._v(" "), _c('th', [_vm._v("Sep")]), _vm._v(" "), _c('th', [_vm._v("Okt")]), _vm._v(" "), _c('th', [_vm._v("Nov")]), _vm._v(" "), _c('th', [_vm._v("Dec")]), _vm._v(" "), _c('th', {
    staticClass: "totals"
  }, [_vm._v("Total")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57bd4472"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings/components/budget.vue
// module id = 869
// module chunks = 0